import { render, staticRenderFns } from "./UnMatchedAcctTrans.vue?vue&type=template&id=70c34374&"
import script from "./UnMatchedAcctTrans.vue?vue&type=script&lang=js&"
export * from "./UnMatchedAcctTrans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports